import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AddCameraWizardModels } from '../../models/wizard.models';

@Component({
    selector: 'app-wizard-detection-method',
    templateUrl: './wizard-detection-method.component.html',
    styleUrls: ['./wizard-detection-method.component.scss'],
    standalone: false,
})
export class WizardDetectionMethodComponent implements OnInit {
    @Output() detectionMethodSelected = new EventEmitter<{
        method: AddCameraWizardModels.DetectionMethod;
        addressRange?: AddCameraWizardModels.AddressRangeData;
    }>();
    @Output() back = new EventEmitter<void>();

    public DetectionMethod = AddCameraWizardModels.DetectionMethod;
    public detectionForm: FormGroup;

    constructor(private fb: FormBuilder) { }

    ngOnInit(): void {
        this.detectionForm = this.fb.group({
            method: [AddCameraWizardModels.DetectionMethod.Express, Validators.required],
            ipStart: [''],
            ipEnd: [''],
            port: [554, [Validators.required, Validators.min(1), Validators.max(65535)]],
        });

        // Emit initial value
        this.emitSelection();

        // Watch form changes
        this.detectionForm.valueChanges.subscribe(() => {
            this.updateValidators();
            this.emitSelection();
        });
    }

    private updateValidators(): void {
        const method = this.detectionForm.get('method')?.value;
        if (method === AddCameraWizardModels.DetectionMethod.AddressRange) {
            this.detectionForm.get('ipStart')?.setValidators([Validators.required, Validators.pattern(/^(\d{1,3}\.){3}\d{1,3}$/)]);
            this.detectionForm.get('ipEnd')?.setValidators([Validators.required, Validators.pattern(/^(\d{1,3}\.){3}\d{1,3}$/)]);
        } else {
            this.detectionForm.get('ipStart')?.clearValidators();
            this.detectionForm.get('ipEnd')?.clearValidators();
        }
        this.detectionForm.get('ipStart')?.updateValueAndValidity({ emitEvent: false });
        this.detectionForm.get('ipEnd')?.updateValueAndValidity({ emitEvent: false });
    }

    private emitSelection(): void {
        if (this.detectionForm.invalid) {
            this.detectionMethodSelected.emit(null!); // Emit null if invalid
            return;
        }

        const method = this.detectionForm.get('method')?.value;
        const data: any = { method };

        if (method === AddCameraWizardModels.DetectionMethod.AddressRange) {
            data.addressRange = {
                ipStart: this.detectionForm.get('ipStart')?.value,
                ipEnd: this.detectionForm.get('ipEnd')?.value,
                port: this.detectionForm.get('port')?.value,
            };
        }

        this.detectionMethodSelected.emit(data);
    }

    public onNext(): void {
        if (this.detectionForm.invalid) {
            return;
        }

        const method = this.detectionForm.get('method')?.value;
        const data: any = { method };

        if (method === AddCameraWizardModels.DetectionMethod.AddressRange) {
            data.addressRange = {
                ipStart: this.detectionForm.get('ipStart')?.value,
                ipEnd: this.detectionForm.get('ipEnd')?.value,
                port: this.detectionForm.get('port')?.value,
            };
        }

        this.detectionMethodSelected.emit(data);
    }

    public onBack(): void {
        this.back.emit();
    }

    public get isNextDisabled(): boolean {
        return this.detectionForm.invalid;
    }

    public get showAddressRangeInputs(): boolean {
        return this.detectionForm.get('method')?.value === AddCameraWizardModels.DetectionMethod.AddressRange;
    }

}
